import { useState } from 'react'
import { toISO } from '../components/finviseMetrics'

const FinviseDateRangeDialog = props => {
	const close = props.handleClose
	const initFrom = props.initialFrom ? new Date(props.initialFrom) : new Date()
	const initTo = props.initialTo ? new Date(props.initialTo) : new Date()

	const [startDate, setStartDate] = useState(toISO(initFrom))
	const [endDate, setEndDate] = useState(toISO(initTo))

	const handleButtonClick = () => {
		if (!startDate || !endDate) return
		const startMs = new Date(startDate + 'T00:00').getTime()
		const endMs = new Date(endDate + 'T00:00').getTime()
		close(startMs, endMs)
	}

	return (
		<div className='range-custom'>
			<div className='lbl'>Custom range</div>
			<div className='fields'>
				<input
					type='date'
					value={startDate}
					onChange={e => setStartDate(e.target.value)}
				/>
				<span style={{ color: 'var(--muted)' }}>→</span>
				<input
					type='date'
					value={endDate}
					onChange={e => setEndDate(e.target.value)}
				/>
			</div>
			<button className='apply' onClick={handleButtonClick}>
				Apply range
			</button>
		</div>
	)
}

export default FinviseDateRangeDialog
